export const TEXT_VARIANTS = ['1000', '900', '800', '700', '600', '200', '100', '100-r', '50', '50-r'];
export const TEXT_SERIF_VARIANTS = [
    '1000-serif',
    '1000-serif-italic',
    '900-serif',
    '900-serif-italic',
    '800-serif',
    '800-serif-italic',
    '700-serif',
    '700-serif-italic',
    '600-serif',
    '600-serif-italic',
    '200-serif',
    '200-serif-italic',
];
export const ADHOC_RICH_TEXT_OPTIONS = [
    'badge',
    'eyebrow-text',
    'stat',
    'stat-serif',
    'center',
    'max-width-none',
];
export const HEADER_ELEMENTS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const TEXT_ELEMENTS = [...HEADER_ELEMENTS, 'p', 'span', 'div'];
